import React from "react";
import { Box, Typography } from "@mui/joy";
import logo from "../images/yeti-clean-logo.png";
import { InlineWidget } from "react-calendly";

export default function ThankYou() {
    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" textAlign="center">
            <Box sx={{width: '100%', justifyContent: 'center', textAlign: 'center'}}>
                <img style={{width: "300px"}} src={logo}/>
            </Box>
            <Typography level="h2" fontWeight={500} sx={{ mb: 1 }}>
                Want to find out more?
            </Typography>
            <Typography fontWeight={400} level="h4">
                Book a Calendly with <Typography fontWeight={500}>Mike</Typography> in your preferred time slot.
            </Typography>
            <Box sx={{ width: '100%', height: '100%'}}>
                <InlineWidget url="https://calendly.com/mikesmithlime/schedule-a-call" />
            </Box>
            <Typography fontWeight={400} level="h4" sx={{marginTop: '25px'}}>
                If you have any issues, please contact <Typography fontWeight={500}>mike@mikesmithfranchising.co.uk</Typography>
            </Typography>

        </Box>
    );
}